import * as i0 from '@angular/core';
import { InjectionToken, inject, TemplateRef, Directive, ViewContainerRef, booleanAttribute, Input, ViewChild, ContentChild, ViewEncapsulation, ChangeDetectionStrategy, Component, ElementRef, ChangeDetectorRef, NgZone, Injector, Renderer2, EventEmitter, afterNextRender, numberAttribute, Output, ContentChildren, QueryList, ViewChildren, computed, signal, HostAttributeToken, forwardRef, NgModule } from '@angular/core';
import { CdkPortal, TemplatePortal, CdkPortalOutlet } from '@angular/cdk/portal';
import { Subject, of, merge, EMPTY, Observable, timer, Subscription, BehaviorSubject } from 'rxjs';
import { _CdkPrivateStyleLoader } from '@angular/cdk/private';
import { _StructuralStylesLoader } from './_structural-styles-chunk.mjs';
import { FocusKeyManager, _IdGenerator, CdkMonitorFocus, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality, BidiModule } from '@angular/cdk/bidi';
import { hasModifierKey, SPACE, ENTER } from '@angular/cdk/keycodes';
import { SharedResizeObserver } from '@angular/cdk/observers/private';
import { Platform } from '@angular/cdk/platform';
import { ViewportRuler, CdkScrollable } from '@angular/cdk/scrolling';
import { debounceTime, takeUntil, startWith, switchMap, skip, filter } from 'rxjs/operators';
import { _animationsDisabled } from './_animation-chunk.mjs';
import { CdkObserveContent } from '@angular/cdk/observers';
import { MatRipple, MAT_RIPPLE_GLOBAL_OPTIONS } from './_ripple-chunk.mjs';
import '@angular/cdk/layout';
import '@angular/cdk/coercion';
const _c0 = ["*"];
function MatTab_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c1 = ["tabListContainer"];
const _c2 = ["tabList"];
const _c3 = ["tabListInner"];
const _c4 = ["nextPaginator"];
const _c5 = ["previousPaginator"];
const _c6 = ["content"];
function MatTabBody_ng_template_2_Template(rf, ctx) {}
const _c7 = ["tabBodyWrapper"];
const _c8 = ["tabHeader"];
function MatTabGroup_For_3_Conditional_6_ng_template_0_Template(rf, ctx) {}
function MatTabGroup_For_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MatTabGroup_For_3_Conditional_6_ng_template_0_Template, 0, 0, "ng-template", 12);
  }
  if (rf & 2) {
    const tab_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cdkPortalOutlet", tab_r3.templateLabel);
  }
}
function MatTabGroup_For_3_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const tab_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate(tab_r3.textLabel);
  }
}
function MatTabGroup_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7, 2);
    i0.ɵɵlistener("click", function MatTabGroup_For_3_Template_div_click_0_listener() {
      const ctx_r1 = i0.ɵɵrestoreView(_r1);
      const tab_r3 = ctx_r1.$implicit;
      const $index_r4 = ctx_r1.$index;
      const ctx_r4 = i0.ɵɵnextContext();
      const tabHeader_r6 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(ctx_r4._handleClick(tab_r3, tabHeader_r6, $index_r4));
    })("cdkFocusChange", function MatTabGroup_For_3_Template_div_cdkFocusChange_0_listener($event) {
      const $index_r4 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4._tabFocusChanged($event, $index_r4));
    });
    i0.ɵɵelement(2, "span", 8)(3, "div", 9);
    i0.ɵɵelementStart(4, "span", 10)(5, "span", 11);
    i0.ɵɵconditionalCreate(6, MatTabGroup_For_3_Conditional_6_Template, 1, 1, null, 12)(7, MatTabGroup_For_3_Conditional_7_Template, 1, 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const $index_r4 = ctx.$index;
    const tabNode_r7 = i0.ɵɵreference(1);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(tab_r3.labelClass);
    i0.ɵɵclassProp("mdc-tab--active", ctx_r4.selectedIndex === $index_r4);
    i0.ɵɵproperty("id", ctx_r4._getTabLabelId(tab_r3, $index_r4))("disabled", tab_r3.disabled)("fitInkBarToContent", ctx_r4.fitInkBarToContent);
    i0.ɵɵattribute("tabIndex", ctx_r4._getTabIndex($index_r4))("aria-posinset", $index_r4 + 1)("aria-setsize", ctx_r4._tabs.length)("aria-controls", ctx_r4._getTabContentId($index_r4))("aria-selected", ctx_r4.selectedIndex === $index_r4)("aria-label", tab_r3.ariaLabel || null)("aria-labelledby", !tab_r3.ariaLabel && tab_r3.ariaLabelledby ? tab_r3.ariaLabelledby : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matRippleTrigger", tabNode_r7)("matRippleDisabled", tab_r3.disabled || ctx_r4.disableRipple);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(tab_r3.templateLabel ? 6 : 7);
  }
}
function MatTabGroup_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function MatTabGroup_For_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab-body", 13);
    i0.ɵɵlistener("_onCentered", function MatTabGroup_For_8_Template_mat_tab_body__onCentered_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4._removeTabBodyWrapperHeight());
    })("_onCentering", function MatTabGroup_For_8_Template_mat_tab_body__onCentering_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4._setTabBodyWrapperHeight($event));
    })("_beforeCentering", function MatTabGroup_For_8_Template_mat_tab_body__beforeCentering_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4._bodyCentered($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r9 = ctx.$implicit;
    const $index_r10 = ctx.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(tab_r9.bodyClass);
    i0.ɵɵproperty("id", ctx_r4._getTabContentId($index_r10))("content", tab_r9.content)("position", tab_r9.position)("animationDuration", ctx_r4._bodyAnimationDuration)("preserveContent", ctx_r4.preserveContent);
    i0.ɵɵattribute("tabindex", ctx_r4.contentTabIndex != null && ctx_r4.selectedIndex === $index_r10 ? ctx_r4.contentTabIndex : null)("aria-labelledby", ctx_r4._getTabLabelId(tab_r9, $index_r10))("aria-hidden", ctx_r4.selectedIndex !== $index_r10);
  }
}
const MAT_TAB_CONTENT = /*#__PURE__*/new InjectionToken('MatTabContent');
let MatTabContent = /*#__PURE__*/(() => {
  class MatTabContent {
    template = inject(TemplateRef);
    static ɵfac = function MatTabContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabContent)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatTabContent,
      selectors: [["", "matTabContent", ""]],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_TAB_CONTENT,
        useExisting: MatTabContent
      }])]
    });
  }
  return MatTabContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAT_TAB_LABEL = /*#__PURE__*/new InjectionToken('MatTabLabel');
const MAT_TAB = /*#__PURE__*/new InjectionToken('MAT_TAB');
let MatTabLabel = /*#__PURE__*/(() => {
  class MatTabLabel extends CdkPortal {
    _closestTab = inject(MAT_TAB, {
      optional: true
    });
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatTabLabel_BaseFactory;
      return function MatTabLabel_Factory(__ngFactoryType__) {
        return (ɵMatTabLabel_BaseFactory || (ɵMatTabLabel_BaseFactory = i0.ɵɵgetInheritedFactory(MatTabLabel)))(__ngFactoryType__ || MatTabLabel);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatTabLabel,
      selectors: [["", "mat-tab-label", ""], ["", "matTabLabel", ""]],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_TAB_LABEL,
        useExisting: MatTabLabel
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatTabLabel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAT_TAB_GROUP = /*#__PURE__*/new InjectionToken('MAT_TAB_GROUP');
let MatTab = /*#__PURE__*/(() => {
  class MatTab {
    _viewContainerRef = inject(ViewContainerRef);
    _closestTabGroup = inject(MAT_TAB_GROUP, {
      optional: true
    });
    disabled = false;
    get templateLabel() {
      return this._templateLabel;
    }
    set templateLabel(value) {
      this._setTemplateLabelInput(value);
    }
    _templateLabel;
    _explicitContent = undefined;
    _implicitContent;
    textLabel = '';
    ariaLabel;
    ariaLabelledby;
    labelClass;
    bodyClass;
    id = null;
    _contentPortal = null;
    get content() {
      return this._contentPortal;
    }
    _stateChanges = new Subject();
    position = null;
    origin = null;
    isActive = false;
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
    }
    ngOnChanges(changes) {
      if (changes.hasOwnProperty('textLabel') || changes.hasOwnProperty('disabled')) {
        this._stateChanges.next();
      }
    }
    ngOnDestroy() {
      this._stateChanges.complete();
    }
    ngOnInit() {
      this._contentPortal = new TemplatePortal(this._explicitContent || this._implicitContent, this._viewContainerRef);
    }
    _setTemplateLabelInput(value) {
      if (value && value._closestTab === this) {
        this._templateLabel = value;
      }
    }
    static ɵfac = function MatTab_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTab)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTab,
      selectors: [["mat-tab"]],
      contentQueries: function MatTab_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatTabLabel, 5)(dirIndex, MatTabContent, 7, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateLabel = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._explicitContent = _t.first);
        }
      },
      viewQuery: function MatTab_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._implicitContent = _t.first);
        }
      },
      hostAttrs: ["hidden", ""],
      hostVars: 1,
      hostBindings: function MatTab_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", null);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        textLabel: [0, "label", "textLabel"],
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"],
        labelClass: "labelClass",
        bodyClass: "bodyClass",
        id: "id"
      },
      exportAs: ["matTab"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_TAB,
        useExisting: MatTab
      }]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function MatTab_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomTemplate(0, MatTab_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 1
    });
  }
  return MatTab;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ACTIVE_CLASS = 'mdc-tab-indicator--active';
const NO_TRANSITION_CLASS = 'mdc-tab-indicator--no-transition';
class MatInkBar {
  _items;
  _currentItem;
  constructor(_items) {
    this._items = _items;
  }
  hide() {
    this._items.forEach(item => item.deactivateInkBar());
    this._currentItem = undefined;
  }
  alignToElement(element) {
    const correspondingItem = this._items.find(item => item.elementRef.nativeElement === element);
    const currentItem = this._currentItem;
    if (correspondingItem === currentItem) {
      return;
    }
    currentItem?.deactivateInkBar();
    if (correspondingItem) {
      const domRect = currentItem?.elementRef.nativeElement.getBoundingClientRect?.();
      correspondingItem.activateInkBar(domRect);
      this._currentItem = correspondingItem;
    }
  }
}
let InkBarItem = /*#__PURE__*/(() => {
  class InkBarItem {
    _elementRef = inject(ElementRef);
    _inkBarElement = null;
    _inkBarContentElement = null;
    _fitToContent = false;
    get fitInkBarToContent() {
      return this._fitToContent;
    }
    set fitInkBarToContent(newValue) {
      if (this._fitToContent !== newValue) {
        this._fitToContent = newValue;
        if (this._inkBarElement) {
          this._appendInkBarElement();
        }
      }
    }
    activateInkBar(previousIndicatorClientRect) {
      const element = this._elementRef.nativeElement;
      if (!previousIndicatorClientRect || !element.getBoundingClientRect || !this._inkBarContentElement) {
        element.classList.add(ACTIVE_CLASS);
        return;
      }
      const currentClientRect = element.getBoundingClientRect();
      const widthDelta = previousIndicatorClientRect.width / currentClientRect.width;
      const xPosition = previousIndicatorClientRect.left - currentClientRect.left;
      element.classList.add(NO_TRANSITION_CLASS);
      this._inkBarContentElement.style.setProperty('transform', `translateX(${xPosition}px) scaleX(${widthDelta})`);
      element.getBoundingClientRect();
      element.classList.remove(NO_TRANSITION_CLASS);
      element.classList.add(ACTIVE_CLASS);
      this._inkBarContentElement.style.setProperty('transform', '');
    }
    deactivateInkBar() {
      this._elementRef.nativeElement.classList.remove(ACTIVE_CLASS);
    }
    ngOnInit() {
      this._createInkBarElement();
    }
    ngOnDestroy() {
      this._inkBarElement?.remove();
      this._inkBarElement = this._inkBarContentElement = null;
    }
    _createInkBarElement() {
      const documentNode = this._elementRef.nativeElement.ownerDocument || document;
      const inkBarElement = this._inkBarElement = documentNode.createElement('span');
      const inkBarContentElement = this._inkBarContentElement = documentNode.createElement('span');
      inkBarElement.className = 'mdc-tab-indicator';
      inkBarContentElement.className = 'mdc-tab-indicator__content mdc-tab-indicator__content--underline';
      inkBarElement.appendChild(this._inkBarContentElement);
      this._appendInkBarElement();
    }
    _appendInkBarElement() {
      if (!this._inkBarElement && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('Ink bar element has not been created and cannot be appended');
      }
      const parentElement = this._fitToContent ? this._elementRef.nativeElement.querySelector('.mdc-tab__content') : this._elementRef.nativeElement;
      if (!parentElement && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('Missing element to host the ink bar');
      }
      parentElement.appendChild(this._inkBarElement);
    }
    static ɵfac = function InkBarItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InkBarItem)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InkBarItem,
      inputs: {
        fitInkBarToContent: [2, "fitInkBarToContent", "fitInkBarToContent", booleanAttribute]
      }
    });
  }
  return InkBarItem;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _MAT_INK_BAR_POSITIONER = /*#__PURE__*/new InjectionToken('MatInkBarPositioner', {
  providedIn: 'root',
  factory: () => {
    const method = element => ({
      left: element ? (element.offsetLeft || 0) + 'px' : '0',
      width: element ? (element.offsetWidth || 0) + 'px' : '0'
    });
    return method;
  }
});
let MatTabLabelWrapper = /*#__PURE__*/(() => {
  class MatTabLabelWrapper extends InkBarItem {
    elementRef = inject(ElementRef);
    disabled = false;
    focus() {
      this.elementRef.nativeElement.focus();
    }
    getOffsetLeft() {
      return this.elementRef.nativeElement.offsetLeft;
    }
    getOffsetWidth() {
      return this.elementRef.nativeElement.offsetWidth;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatTabLabelWrapper_BaseFactory;
      return function MatTabLabelWrapper_Factory(__ngFactoryType__) {
        return (ɵMatTabLabelWrapper_BaseFactory || (ɵMatTabLabelWrapper_BaseFactory = i0.ɵɵgetInheritedFactory(MatTabLabelWrapper)))(__ngFactoryType__ || MatTabLabelWrapper);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatTabLabelWrapper,
      selectors: [["", "matTabLabelWrapper", ""]],
      hostVars: 3,
      hostBindings: function MatTabLabelWrapper_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-disabled", !!ctx.disabled);
          i0.ɵɵclassProp("mat-mdc-tab-disabled", ctx.disabled);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatTabLabelWrapper;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const passiveEventListenerOptions = {
  passive: true
};
const HEADER_SCROLL_DELAY = 650;
const HEADER_SCROLL_INTERVAL = 100;
function normalizeDuration(value) {
  const stringValue = value + '';
  if (/^[0-9]+(?:\.[0-9]+)?$/.test(stringValue)) {
    return `${value}ms`;
  } else if (/^[0-9]+(?:\.[0-9]+)?(?:ms|s)$/.test(stringValue)) {
    return stringValue;
  } else {
    return '';
  }
}
let MatPaginatedTabHeader = /*#__PURE__*/(() => {
  class MatPaginatedTabHeader {
    _elementRef = inject(ElementRef);
    _changeDetectorRef = inject(ChangeDetectorRef);
    _viewportRuler = inject(ViewportRuler);
    _dir = inject(Directionality, {
      optional: true
    });
    _ngZone = inject(NgZone);
    _platform = inject(Platform);
    _sharedResizeObserver = inject(SharedResizeObserver);
    _injector = inject(Injector);
    _renderer = inject(Renderer2);
    _animationsDisabled = _animationsDisabled();
    _eventCleanups;
    _scrollDistance = 0;
    _selectedIndexChanged = false;
    _destroyed = new Subject();
    _showPaginationControls = false;
    _disableScrollAfter = true;
    _disableScrollBefore = true;
    _tabLabelCount;
    _scrollDistanceChanged = false;
    _keyManager;
    _currentTextContent;
    _stopScrolling = new Subject();
    disablePagination = false;
    get selectedIndex() {
      return this._selectedIndex;
    }
    set selectedIndex(v) {
      const value = isNaN(v) ? 0 : v;
      if (this._selectedIndex != value) {
        this._selectedIndexChanged = true;
        this._selectedIndex = value;
        if (this._keyManager) {
          this._keyManager.updateActiveItem(value);
        }
      }
    }
    _selectedIndex = 0;
    selectFocusedIndex = new EventEmitter();
    indexFocused = new EventEmitter();
    constructor() {
      this._eventCleanups = this._ngZone.runOutsideAngular(() => [this._renderer.listen(this._elementRef.nativeElement, 'mouseleave', () => this._stopInterval())]);
    }
    ngAfterViewInit() {
      this._eventCleanups.push(this._renderer.listen(this._previousPaginator.nativeElement, 'touchstart', () => this._handlePaginatorPress('before'), passiveEventListenerOptions), this._renderer.listen(this._nextPaginator.nativeElement, 'touchstart', () => this._handlePaginatorPress('after'), passiveEventListenerOptions));
    }
    ngAfterContentInit() {
      const dirChange = this._dir ? this._dir.change : of('ltr');
      const resize = this._sharedResizeObserver.observe(this._elementRef.nativeElement).pipe(debounceTime(32), takeUntil(this._destroyed));
      const viewportResize = this._viewportRuler.change(150).pipe(takeUntil(this._destroyed));
      const realign = () => {
        this.updatePagination();
        this._alignInkBarToSelectedTab();
      };
      this._keyManager = new FocusKeyManager(this._items).withHorizontalOrientation(this._getLayoutDirection()).withHomeAndEnd().withWrap().skipPredicate(() => false);
      this._keyManager.updateActiveItem(Math.max(this._selectedIndex, 0));
      afterNextRender(realign, {
        injector: this._injector
      });
      merge(dirChange, viewportResize, resize, this._items.changes, this._itemsResized()).pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._ngZone.run(() => {
          Promise.resolve().then(() => {
            this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), this._scrollDistance));
            realign();
          });
        });
        this._keyManager?.withHorizontalOrientation(this._getLayoutDirection());
      });
      this._keyManager.change.subscribe(newFocusIndex => {
        this.indexFocused.emit(newFocusIndex);
        this._setTabFocus(newFocusIndex);
      });
    }
    _itemsResized() {
      if (typeof ResizeObserver !== 'function') {
        return EMPTY;
      }
      return this._items.changes.pipe(startWith(this._items), switchMap(tabItems => new Observable(observer => this._ngZone.runOutsideAngular(() => {
        const resizeObserver = new ResizeObserver(entries => observer.next(entries));
        tabItems.forEach(item => resizeObserver.observe(item.elementRef.nativeElement));
        return () => {
          resizeObserver.disconnect();
        };
      }))), skip(1), filter(entries => entries.some(e => e.contentRect.width > 0 && e.contentRect.height > 0)));
    }
    ngAfterContentChecked() {
      if (this._tabLabelCount != this._items.length) {
        this.updatePagination();
        this._tabLabelCount = this._items.length;
        this._changeDetectorRef.markForCheck();
      }
      if (this._selectedIndexChanged) {
        this._scrollToLabel(this._selectedIndex);
        this._checkScrollingControls();
        this._alignInkBarToSelectedTab();
        this._selectedIndexChanged = false;
        this._changeDetectorRef.markForCheck();
      }
      if (this._scrollDistanceChanged) {
        this._updateTabScrollPosition();
        this._scrollDistanceChanged = false;
        this._changeDetectorRef.markForCheck();
      }
    }
    ngOnDestroy() {
      this._eventCleanups.forEach(cleanup => cleanup());
      this._keyManager?.destroy();
      this._destroyed.next();
      this._destroyed.complete();
      this._stopScrolling.complete();
    }
    _handleKeydown(event) {
      if (hasModifierKey(event)) {
        return;
      }
      switch (event.keyCode) {
        case ENTER:
        case SPACE:
          if (this.focusIndex !== this.selectedIndex) {
            const item = this._items.get(this.focusIndex);
            if (item && !item.disabled) {
              this.selectFocusedIndex.emit(this.focusIndex);
              this._itemSelected(event);
            }
          }
          break;
        default:
          this._keyManager?.onKeydown(event);
      }
    }
    _onContentChanges() {
      const textContent = this._elementRef.nativeElement.textContent;
      if (textContent !== this._currentTextContent) {
        this._currentTextContent = textContent || '';
        this._ngZone.run(() => {
          this.updatePagination();
          this._alignInkBarToSelectedTab();
          this._changeDetectorRef.markForCheck();
        });
      }
    }
    updatePagination() {
      this._checkPaginationEnabled();
      this._checkScrollingControls();
      this._updateTabScrollPosition();
    }
    get focusIndex() {
      return this._keyManager ? this._keyManager.activeItemIndex : 0;
    }
    set focusIndex(value) {
      if (!this._isValidIndex(value) || this.focusIndex === value || !this._keyManager) {
        return;
      }
      this._keyManager.setActiveItem(value);
    }
    _isValidIndex(index) {
      return this._items ? !!this._items.toArray()[index] : true;
    }
    _setTabFocus(tabIndex) {
      if (this._showPaginationControls) {
        this._scrollToLabel(tabIndex);
      }
      if (this._items && this._items.length) {
        this._items.toArray()[tabIndex].focus();
        const containerEl = this._tabListContainer.nativeElement;
        const dir = this._getLayoutDirection();
        if (dir == 'ltr') {
          containerEl.scrollLeft = 0;
        } else {
          containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
        }
      }
    }
    _getLayoutDirection() {
      return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    }
    _updateTabScrollPosition() {
      if (this.disablePagination) {
        return;
      }
      const scrollDistance = this.scrollDistance;
      const translateX = this._getLayoutDirection() === 'ltr' ? -scrollDistance : scrollDistance;
      this._tabList.nativeElement.style.transform = `translateX(${Math.round(translateX)}px)`;
      if (this._platform.TRIDENT || this._platform.EDGE) {
        this._tabListContainer.nativeElement.scrollLeft = 0;
      }
    }
    get scrollDistance() {
      return this._scrollDistance;
    }
    set scrollDistance(value) {
      this._scrollTo(value);
    }
    _scrollHeader(direction) {
      const viewLength = this._tabListContainer.nativeElement.offsetWidth;
      const scrollAmount = (direction == 'before' ? -1 : 1) * viewLength / 3;
      return this._scrollTo(this._scrollDistance + scrollAmount);
    }
    _handlePaginatorClick(direction) {
      this._stopInterval();
      this._scrollHeader(direction);
    }
    _scrollToLabel(labelIndex) {
      if (this.disablePagination) {
        return;
      }
      const selectedLabel = this._items ? this._items.toArray()[labelIndex] : null;
      if (!selectedLabel) {
        return;
      }
      const viewLength = this._tabListContainer.nativeElement.offsetWidth;
      const {
        offsetLeft,
        offsetWidth
      } = selectedLabel.elementRef.nativeElement;
      let labelBeforePos, labelAfterPos;
      if (this._getLayoutDirection() == 'ltr') {
        labelBeforePos = offsetLeft;
        labelAfterPos = labelBeforePos + offsetWidth;
      } else {
        labelAfterPos = this._tabListInner.nativeElement.offsetWidth - offsetLeft;
        labelBeforePos = labelAfterPos - offsetWidth;
      }
      const beforeVisiblePos = this.scrollDistance;
      const afterVisiblePos = this.scrollDistance + viewLength;
      if (labelBeforePos < beforeVisiblePos) {
        this.scrollDistance -= beforeVisiblePos - labelBeforePos;
      } else if (labelAfterPos > afterVisiblePos) {
        this.scrollDistance += Math.min(labelAfterPos - afterVisiblePos, labelBeforePos - beforeVisiblePos);
      }
    }
    _checkPaginationEnabled() {
      if (this.disablePagination) {
        this._showPaginationControls = false;
      } else {
        const scrollWidth = this._tabListInner.nativeElement.scrollWidth;
        const containerWidth = this._elementRef.nativeElement.offsetWidth;
        const isEnabled = scrollWidth - containerWidth >= 5;
        if (!isEnabled) {
          this.scrollDistance = 0;
        }
        if (isEnabled !== this._showPaginationControls) {
          this._showPaginationControls = isEnabled;
          this._changeDetectorRef.markForCheck();
        }
      }
    }
    _checkScrollingControls() {
      if (this.disablePagination) {
        this._disableScrollAfter = this._disableScrollBefore = true;
      } else {
        this._disableScrollBefore = this.scrollDistance == 0;
        this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
        this._changeDetectorRef.markForCheck();
      }
    }
    _getMaxScrollDistance() {
      const lengthOfTabList = this._tabListInner.nativeElement.scrollWidth;
      const viewLength = this._tabListContainer.nativeElement.offsetWidth;
      return lengthOfTabList - viewLength || 0;
    }
    _alignInkBarToSelectedTab() {
      const selectedItem = this._items && this._items.length ? this._items.toArray()[this.selectedIndex] : null;
      const selectedLabelWrapper = selectedItem ? selectedItem.elementRef.nativeElement : null;
      if (selectedLabelWrapper) {
        this._inkBar.alignToElement(selectedLabelWrapper);
      } else {
        this._inkBar.hide();
      }
    }
    _stopInterval() {
      this._stopScrolling.next();
    }
    _handlePaginatorPress(direction, mouseEvent) {
      if (mouseEvent && mouseEvent.button != null && mouseEvent.button !== 0) {
        return;
      }
      this._stopInterval();
      timer(HEADER_SCROLL_DELAY, HEADER_SCROLL_INTERVAL).pipe(takeUntil(merge(this._stopScrolling, this._destroyed))).subscribe(() => {
        const {
          maxScrollDistance,
          distance
        } = this._scrollHeader(direction);
        if (distance === 0 || distance >= maxScrollDistance) {
          this._stopInterval();
        }
      });
    }
    _scrollTo(position) {
      if (this.disablePagination) {
        return {
          maxScrollDistance: 0,
          distance: 0
        };
      }
      const maxScrollDistance = this._getMaxScrollDistance();
      this._scrollDistance = Math.max(0, Math.min(maxScrollDistance, position));
      this._scrollDistanceChanged = true;
      this._checkScrollingControls();
      return {
        maxScrollDistance,
        distance: this._scrollDistance
      };
    }
    static ɵfac = function MatPaginatedTabHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatPaginatedTabHeader)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatPaginatedTabHeader,
      inputs: {
        disablePagination: [2, "disablePagination", "disablePagination", booleanAttribute],
        selectedIndex: [2, "selectedIndex", "selectedIndex", numberAttribute]
      },
      outputs: {
        selectFocusedIndex: "selectFocusedIndex",
        indexFocused: "indexFocused"
      }
    });
  }
  return MatPaginatedTabHeader;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabHeader = /*#__PURE__*/(() => {
  class MatTabHeader extends MatPaginatedTabHeader {
    _items;
    _tabListContainer;
    _tabList;
    _tabListInner;
    _nextPaginator;
    _previousPaginator;
    _inkBar;
    ariaLabel;
    ariaLabelledby;
    disableRipple = false;
    ngAfterContentInit() {
      this._inkBar = new MatInkBar(this._items);
      super.ngAfterContentInit();
    }
    _itemSelected(event) {
      event.preventDefault();
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatTabHeader_BaseFactory;
      return function MatTabHeader_Factory(__ngFactoryType__) {
        return (ɵMatTabHeader_BaseFactory || (ɵMatTabHeader_BaseFactory = i0.ɵɵgetInheritedFactory(MatTabHeader)))(__ngFactoryType__ || MatTabHeader);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabHeader,
      selectors: [["mat-tab-header"]],
      contentQueries: function MatTabHeader_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatTabLabelWrapper, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._items = _t);
        }
      },
      viewQuery: function MatTabHeader_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 7)(_c2, 7)(_c3, 7)(_c4, 5)(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabListContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabListInner = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nextPaginator = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._previousPaginator = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-tab-header"],
      hostVars: 4,
      hostBindings: function MatTabHeader_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-controls-enabled", ctx._showPaginationControls)("mat-mdc-tab-header-rtl", ctx._getLayoutDirection() == "rtl");
        }
      },
      inputs: {
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"],
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute]
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 13,
      vars: 10,
      consts: [["previousPaginator", ""], ["tabListContainer", ""], ["tabList", ""], ["tabListInner", ""], ["nextPaginator", ""], ["mat-ripple", "", 1, "mat-mdc-tab-header-pagination", "mat-mdc-tab-header-pagination-before", 3, "click", "mousedown", "touchend", "matRippleDisabled"], [1, "mat-mdc-tab-header-pagination-chevron"], [1, "mat-mdc-tab-label-container", 3, "keydown"], ["role", "tablist", 1, "mat-mdc-tab-list", 3, "cdkObserveContent"], [1, "mat-mdc-tab-labels"], ["mat-ripple", "", 1, "mat-mdc-tab-header-pagination", "mat-mdc-tab-header-pagination-after", 3, "mousedown", "click", "touchend", "matRippleDisabled"]],
      template: function MatTabHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 5, 0);
          i0.ɵɵlistener("click", function MatTabHeader_Template_div_click_0_listener() {
            return ctx._handlePaginatorClick("before");
          })("mousedown", function MatTabHeader_Template_div_mousedown_0_listener($event) {
            return ctx._handlePaginatorPress("before", $event);
          })("touchend", function MatTabHeader_Template_div_touchend_0_listener() {
            return ctx._stopInterval();
          });
          i0.ɵɵelement(2, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 7, 1);
          i0.ɵɵlistener("keydown", function MatTabHeader_Template_div_keydown_3_listener($event) {
            return ctx._handleKeydown($event);
          });
          i0.ɵɵelementStart(5, "div", 8, 2);
          i0.ɵɵlistener("cdkObserveContent", function MatTabHeader_Template_div_cdkObserveContent_5_listener() {
            return ctx._onContentChanges();
          });
          i0.ɵɵelementStart(7, "div", 9, 3);
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(10, "div", 10, 4);
          i0.ɵɵlistener("mousedown", function MatTabHeader_Template_div_mousedown_10_listener($event) {
            return ctx._handlePaginatorPress("after", $event);
          })("click", function MatTabHeader_Template_div_click_10_listener() {
            return ctx._handlePaginatorClick("after");
          })("touchend", function MatTabHeader_Template_div_touchend_10_listener() {
            return ctx._stopInterval();
          });
          i0.ɵɵelement(12, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-disabled", ctx._disableScrollBefore);
          i0.ɵɵproperty("matRippleDisabled", ctx._disableScrollBefore || ctx.disableRipple);
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("_mat-animation-noopable", ctx._animationsDisabled);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel || null)("aria-labelledby", ctx.ariaLabelledby || null);
          i0.ɵɵadvance(5);
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-disabled", ctx._disableScrollAfter);
          i0.ɵɵproperty("matRippleDisabled", ctx._disableScrollAfter || ctx.disableRipple);
        }
      },
      dependencies: [MatRipple, CdkObserveContent],
      styles: [".mat-mdc-tab-header {\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.mdc-tab-indicator .mdc-tab-indicator__content {\n  transition-duration: var(--mat-tab-header-animation-duration, 250ms);\n}\n\n.mat-mdc-tab-header-pagination {\n  -webkit-user-select: none;\n  user-select: none;\n  position: relative;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  min-width: 32px;\n  cursor: pointer;\n  z-index: 2;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: none;\n  box-sizing: content-box;\n  outline: 0;\n}\n.mat-mdc-tab-header-pagination::-moz-focus-inner {\n  border: 0;\n}\n.mat-mdc-tab-header-pagination .mat-ripple-element {\n  opacity: 0.12;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {\n  display: flex;\n}\n\n.mat-mdc-tab-header-pagination-before,\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-after {\n  padding-left: 4px;\n}\n.mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-after .mat-mdc-tab-header-pagination-chevron {\n  transform: rotate(-135deg);\n}\n\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-before,\n.mat-mdc-tab-header-pagination-after {\n  padding-right: 4px;\n}\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-header-pagination-after .mat-mdc-tab-header-pagination-chevron {\n  transform: rotate(45deg);\n}\n\n.mat-mdc-tab-header-pagination-chevron {\n  border-style: solid;\n  border-width: 2px 2px 0 0;\n  height: 8px;\n  width: 8px;\n  border-color: var(--mat-tab-pagination-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-tab-header-pagination-disabled {\n  box-shadow: none;\n  cursor: default;\n  pointer-events: none;\n}\n.mat-mdc-tab-header-pagination-disabled .mat-mdc-tab-header-pagination-chevron {\n  opacity: 0.4;\n}\n\n.mat-mdc-tab-list {\n  flex-grow: 1;\n  position: relative;\n  transition: transform 500ms cubic-bezier(0.35, 0, 0.25, 1);\n}\n._mat-animation-noopable .mat-mdc-tab-list {\n  transition: none;\n}\n\n.mat-mdc-tab-label-container {\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  z-index: 1;\n  border-bottom-style: solid;\n  border-bottom-width: var(--mat-tab-divider-height, 1px);\n  border-bottom-color: var(--mat-tab-divider-color, var(--mat-sys-surface-variant));\n}\n.mat-mdc-tab-group-inverted-header .mat-mdc-tab-label-container {\n  border-bottom: none;\n  border-top-style: solid;\n  border-top-width: var(--mat-tab-divider-height, 1px);\n  border-top-color: var(--mat-tab-divider-color, var(--mat-sys-surface-variant));\n}\n\n.mat-mdc-tab-labels {\n  display: flex;\n  flex: 1 0 auto;\n}\n[mat-align-tabs=center] > .mat-mdc-tab-header .mat-mdc-tab-labels {\n  justify-content: center;\n}\n[mat-align-tabs=end] > .mat-mdc-tab-header .mat-mdc-tab-labels {\n  justify-content: flex-end;\n}\n.cdk-drop-list .mat-mdc-tab-labels, .mat-mdc-tab-labels.cdk-drop-list {\n  min-height: var(--mat-tab-container-height, 48px);\n}\n\n.mat-mdc-tab::before {\n  margin: 5px;\n}\n@media (forced-colors: active) {\n  .mat-mdc-tab[aria-disabled=true] {\n    color: GrayText;\n  }\n}\n"],
      encapsulation: 2,
      changeDetection: 1
    });
  }
  return MatTabHeader;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAT_TABS_CONFIG = /*#__PURE__*/new InjectionToken('MAT_TABS_CONFIG');
let MatTabBodyPortal = /*#__PURE__*/(() => {
  class MatTabBodyPortal extends CdkPortalOutlet {
    _host = inject(MatTabBody);
    _ngZone = inject(NgZone);
    _centeringSub = Subscription.EMPTY;
    _leavingSub = Subscription.EMPTY;
    ngOnInit() {
      super.ngOnInit();
      this._centeringSub = this._host._beforeCentering.pipe(startWith(this._host._isCenterPosition())).subscribe(isCentering => {
        if (this._host._content && isCentering && !this.hasAttached()) {
          this._ngZone.run(() => {
            Promise.resolve().then();
            this.attach(this._host._content);
          });
        }
      });
      this._leavingSub = this._host._afterLeavingCenter.subscribe(() => {
        if (!this._host.preserveContent) {
          this._ngZone.run(() => this.detach());
        }
      });
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this._centeringSub.unsubscribe();
      this._leavingSub.unsubscribe();
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatTabBodyPortal_BaseFactory;
      return function MatTabBodyPortal_Factory(__ngFactoryType__) {
        return (ɵMatTabBodyPortal_BaseFactory || (ɵMatTabBodyPortal_BaseFactory = i0.ɵɵgetInheritedFactory(MatTabBodyPortal)))(__ngFactoryType__ || MatTabBodyPortal);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatTabBodyPortal,
      selectors: [["", "matTabBodyHost", ""]],
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatTabBodyPortal;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabBody = /*#__PURE__*/(() => {
  class MatTabBody {
    _elementRef = inject(ElementRef);
    _dir = inject(Directionality, {
      optional: true
    });
    _ngZone = inject(NgZone);
    _injector = inject(Injector);
    _renderer = inject(Renderer2);
    _diAnimationsDisabled = _animationsDisabled();
    _eventCleanups;
    _initialized = false;
    _fallbackTimer;
    _positionIndex;
    _dirChangeSubscription = Subscription.EMPTY;
    _position;
    _previousPosition;
    _onCentering = new EventEmitter();
    _beforeCentering = new EventEmitter();
    _afterLeavingCenter = new EventEmitter();
    _onCentered = new EventEmitter(true);
    _portalHost;
    _contentElement;
    _content;
    animationDuration = '500ms';
    preserveContent = false;
    set position(position) {
      this._positionIndex = position;
      this._computePositionAnimationState();
    }
    constructor() {
      if (this._dir) {
        const changeDetectorRef = inject(ChangeDetectorRef);
        this._dirChangeSubscription = this._dir.change.subscribe(dir => {
          this._computePositionAnimationState(dir);
          changeDetectorRef.markForCheck();
        });
      }
    }
    ngOnInit() {
      this._bindTransitionEvents();
      if (this._position === 'center') {
        this._setActiveClass(true);
        afterNextRender(() => this._onCentering.emit(this._elementRef.nativeElement.clientHeight), {
          injector: this._injector
        });
      }
      this._initialized = true;
    }
    ngOnDestroy() {
      clearTimeout(this._fallbackTimer);
      this._eventCleanups?.forEach(cleanup => cleanup());
      this._dirChangeSubscription.unsubscribe();
    }
    _bindTransitionEvents() {
      this._ngZone.runOutsideAngular(() => {
        const element = this._elementRef.nativeElement;
        const transitionDone = event => {
          if (event.target === this._contentElement?.nativeElement) {
            this._elementRef.nativeElement.classList.remove('mat-tab-body-animating');
            if (event.type === 'transitionend') {
              this._transitionDone();
            }
          }
        };
        this._eventCleanups = [this._renderer.listen(element, 'transitionstart', event => {
          if (event.target === this._contentElement?.nativeElement) {
            this._elementRef.nativeElement.classList.add('mat-tab-body-animating');
            this._transitionStarted();
          }
        }), this._renderer.listen(element, 'transitionend', transitionDone), this._renderer.listen(element, 'transitioncancel', transitionDone)];
      });
    }
    _transitionStarted() {
      clearTimeout(this._fallbackTimer);
      const isCentering = this._position === 'center';
      this._beforeCentering.emit(isCentering);
      if (isCentering) {
        this._onCentering.emit(this._elementRef.nativeElement.clientHeight);
      }
    }
    _transitionDone() {
      if (this._position === 'center') {
        this._onCentered.emit();
      } else if (this._previousPosition === 'center') {
        this._afterLeavingCenter.emit();
      }
    }
    _setActiveClass(isActive) {
      this._elementRef.nativeElement.classList.toggle('mat-mdc-tab-body-active', isActive);
    }
    _getLayoutDirection() {
      return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    }
    _isCenterPosition() {
      return this._positionIndex === 0;
    }
    _computePositionAnimationState(dir = this._getLayoutDirection()) {
      this._previousPosition = this._position;
      if (this._positionIndex < 0) {
        this._position = dir == 'ltr' ? 'left' : 'right';
      } else if (this._positionIndex > 0) {
        this._position = dir == 'ltr' ? 'right' : 'left';
      } else {
        this._position = 'center';
      }
      if (this._animationsDisabled()) {
        this._simulateTransitionEvents();
      } else if (this._initialized && (this._position === 'center' || this._previousPosition === 'center')) {
        clearTimeout(this._fallbackTimer);
        this._fallbackTimer = this._ngZone.runOutsideAngular(() => setTimeout(() => this._simulateTransitionEvents(), 100));
      }
    }
    _simulateTransitionEvents() {
      this._transitionStarted();
      afterNextRender(() => this._transitionDone(), {
        injector: this._injector
      });
    }
    _animationsDisabled() {
      return this._diAnimationsDisabled || this.animationDuration === '0ms' || this.animationDuration === '0s';
    }
    static ɵfac = function MatTabBody_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabBody)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabBody,
      selectors: [["mat-tab-body"]],
      viewQuery: function MatTabBody_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatTabBodyPortal, 5)(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._portalHost = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._contentElement = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-tab-body"],
      hostVars: 1,
      hostBindings: function MatTabBody_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("inert", ctx._position === "center" ? null : "");
        }
      },
      inputs: {
        _content: [0, "content", "_content"],
        animationDuration: "animationDuration",
        preserveContent: "preserveContent",
        position: "position"
      },
      outputs: {
        _onCentering: "_onCentering",
        _beforeCentering: "_beforeCentering",
        _onCentered: "_onCentered"
      },
      decls: 3,
      vars: 6,
      consts: [["content", ""], ["cdkScrollable", "", 1, "mat-mdc-tab-body-content"], ["matTabBodyHost", ""]],
      template: function MatTabBody_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵtemplate(2, MatTabBody_ng_template_2_Template, 0, 0, "ng-template", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("mat-tab-body-content-left", ctx._position === "left")("mat-tab-body-content-right", ctx._position === "right")("mat-tab-body-content-can-animate", ctx._position === "center" || ctx._previousPosition === "center");
        }
      },
      dependencies: [MatTabBodyPortal, CdkScrollable],
      styles: [".mat-mdc-tab-body {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  display: block;\n  overflow: hidden;\n  outline: 0;\n  flex-basis: 100%;\n}\n.mat-mdc-tab-body.mat-mdc-tab-body-active {\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 1;\n  flex-grow: 1;\n}\n.mat-mdc-tab-group.mat-mdc-tab-group-dynamic-height .mat-mdc-tab-body.mat-mdc-tab-body-active {\n  overflow-y: hidden;\n}\n\n.mat-mdc-tab-body-content {\n  height: 100%;\n  overflow: auto;\n  transform: none;\n  visibility: hidden;\n}\n.mat-tab-body-animating > .mat-mdc-tab-body-content, .mat-mdc-tab-body-active > .mat-mdc-tab-body-content {\n  visibility: visible;\n}\n.mat-tab-body-animating > .mat-mdc-tab-body-content {\n  min-height: 1px;\n}\n.mat-mdc-tab-group-dynamic-height .mat-mdc-tab-body-content {\n  overflow: hidden;\n}\n\n.mat-tab-body-content-can-animate {\n  transition: transform var(--mat-tab-body-animation-duration) 1ms cubic-bezier(0.35, 0, 0.25, 1);\n}\n.mat-mdc-tab-body-wrapper._mat-animation-noopable .mat-tab-body-content-can-animate {\n  transition: none;\n}\n\n.mat-tab-body-content-left {\n  transform: translate3d(-100%, 0, 0);\n}\n\n.mat-tab-body-content-right {\n  transform: translate3d(100%, 0, 0);\n}\n"],
      encapsulation: 2,
      changeDetection: 1
    });
  }
  return MatTabBody;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabGroup = /*#__PURE__*/(() => {
  class MatTabGroup {
    _elementRef = inject(ElementRef);
    _changeDetectorRef = inject(ChangeDetectorRef);
    _ngZone = inject(NgZone);
    _tabsSubscription = Subscription.EMPTY;
    _tabLabelSubscription = Subscription.EMPTY;
    _tabBodySubscription = Subscription.EMPTY;
    _diAnimationsDisabled = _animationsDisabled();
    _bodyAnimationDuration;
    _headerAnimationDuration;
    _allTabs;
    _tabBodies;
    _tabBodyWrapper;
    _tabHeader;
    _tabs = new QueryList();
    _indexToSelect = 0;
    _lastFocusedTabIndex = null;
    _tabBodyWrapperHeight = 0;
    color;
    get fitInkBarToContent() {
      return this._fitInkBarToContent;
    }
    set fitInkBarToContent(value) {
      this._fitInkBarToContent = value;
      this._changeDetectorRef.markForCheck();
    }
    _fitInkBarToContent = false;
    stretchTabs = true;
    alignTabs = null;
    dynamicHeight = false;
    get selectedIndex() {
      return this._selectedIndex;
    }
    set selectedIndex(value) {
      this._indexToSelect = isNaN(value) ? null : value;
    }
    _selectedIndex = null;
    headerPosition = 'above';
    get animationDuration() {
      return this._animationDuration;
    }
    set animationDuration(value) {
      this._animationDuration = value;
      if (value && typeof value === 'object') {
        this._bodyAnimationDuration = normalizeDuration(value.body);
        this._headerAnimationDuration = normalizeDuration(value.header);
      } else {
        this._headerAnimationDuration = this._bodyAnimationDuration = normalizeDuration(value);
      }
    }
    _animationDuration;
    get contentTabIndex() {
      return this._contentTabIndex;
    }
    set contentTabIndex(value) {
      this._contentTabIndex = isNaN(value) ? null : value;
    }
    _contentTabIndex = null;
    disablePagination = false;
    disableRipple = false;
    preserveContent = false;
    get backgroundColor() {
      return this._backgroundColor;
    }
    set backgroundColor(value) {
      const classList = this._elementRef.nativeElement.classList;
      classList.remove('mat-tabs-with-background', `mat-background-${this.backgroundColor}`);
      if (value) {
        classList.add('mat-tabs-with-background', `mat-background-${value}`);
      }
      this._backgroundColor = value;
    }
    _backgroundColor;
    ariaLabel;
    ariaLabelledby;
    selectedIndexChange = new EventEmitter();
    focusChange = new EventEmitter();
    animationDone = new EventEmitter();
    selectedTabChange = new EventEmitter(true);
    _groupId;
    _isServer = !inject(Platform).isBrowser;
    constructor() {
      const defaultConfig = inject(MAT_TABS_CONFIG, {
        optional: true
      });
      this._groupId = inject(_IdGenerator).getId('mat-tab-group-');
      this.animationDuration = defaultConfig && defaultConfig.animationDuration ? defaultConfig.animationDuration : '500ms';
      this.disablePagination = defaultConfig && defaultConfig.disablePagination != null ? defaultConfig.disablePagination : false;
      this.dynamicHeight = defaultConfig && defaultConfig.dynamicHeight != null ? defaultConfig.dynamicHeight : false;
      if (defaultConfig?.contentTabIndex != null) {
        this.contentTabIndex = defaultConfig.contentTabIndex;
      }
      this.preserveContent = !!defaultConfig?.preserveContent;
      this.fitInkBarToContent = defaultConfig && defaultConfig.fitInkBarToContent != null ? defaultConfig.fitInkBarToContent : false;
      this.stretchTabs = defaultConfig && defaultConfig.stretchTabs != null ? defaultConfig.stretchTabs : true;
      this.alignTabs = defaultConfig && defaultConfig.alignTabs != null ? defaultConfig.alignTabs : null;
    }
    ngAfterContentChecked() {
      const indexToSelect = this._indexToSelect = this._clampTabIndex(this._indexToSelect);
      if (this._selectedIndex != indexToSelect) {
        const isFirstRun = this._selectedIndex == null;
        if (!isFirstRun) {
          this.selectedTabChange.emit(this._createChangeEvent(indexToSelect));
          const wrapper = this._tabBodyWrapper.nativeElement;
          wrapper.style.minHeight = wrapper.clientHeight + 'px';
        }
        Promise.resolve().then(() => {
          this._tabs.forEach((tab, index) => tab.isActive = index === indexToSelect);
          if (!isFirstRun) {
            this.selectedIndexChange.emit(indexToSelect);
            this._tabBodyWrapper.nativeElement.style.minHeight = '';
          }
        });
      }
      this._tabs.forEach((tab, index) => {
        tab.position = index - indexToSelect;
        if (this._selectedIndex != null && tab.position == 0 && !tab.origin) {
          tab.origin = indexToSelect - this._selectedIndex;
        }
      });
      if (this._selectedIndex !== indexToSelect) {
        this._selectedIndex = indexToSelect;
        this._lastFocusedTabIndex = null;
        this._changeDetectorRef.markForCheck();
      }
    }
    ngAfterContentInit() {
      this._subscribeToAllTabChanges();
      this._subscribeToTabLabels();
      this._tabsSubscription = this._tabs.changes.subscribe(() => {
        const indexToSelect = this._clampTabIndex(this._indexToSelect);
        if (indexToSelect === this._selectedIndex) {
          const tabs = this._tabs.toArray();
          let selectedTab;
          for (let i = 0; i < tabs.length; i++) {
            if (tabs[i].isActive) {
              this._indexToSelect = this._selectedIndex = i;
              this._lastFocusedTabIndex = null;
              selectedTab = tabs[i];
              break;
            }
          }
          if (!selectedTab && tabs[indexToSelect]) {
            Promise.resolve().then(() => {
              tabs[indexToSelect].isActive = true;
              this.selectedTabChange.emit(this._createChangeEvent(indexToSelect));
            });
          }
        }
        this._changeDetectorRef.markForCheck();
      });
    }
    ngAfterViewInit() {
      this._tabBodySubscription = this._tabBodies.changes.subscribe(() => this._bodyCentered(true));
    }
    _subscribeToAllTabChanges() {
      this._allTabs.changes.pipe(startWith(this._allTabs)).subscribe(tabs => {
        this._tabs.reset(tabs.filter(tab => {
          return tab._closestTabGroup === this || !tab._closestTabGroup;
        }));
        this._tabs.notifyOnChanges();
      });
    }
    ngOnDestroy() {
      this._tabs.destroy();
      this._tabsSubscription.unsubscribe();
      this._tabLabelSubscription.unsubscribe();
      this._tabBodySubscription.unsubscribe();
    }
    realignInkBar() {
      if (this._tabHeader) {
        this._tabHeader._alignInkBarToSelectedTab();
      }
    }
    updatePagination() {
      if (this._tabHeader) {
        this._tabHeader.updatePagination();
      }
    }
    focusTab(index) {
      const header = this._tabHeader;
      if (header) {
        header.focusIndex = index;
      }
    }
    _focusChanged(index) {
      this._lastFocusedTabIndex = index;
      this.focusChange.emit(this._createChangeEvent(index));
    }
    _createChangeEvent(index) {
      const event = new MatTabChangeEvent();
      event.index = index;
      if (this._tabs && this._tabs.length) {
        event.tab = this._tabs.toArray()[index];
      }
      return event;
    }
    _subscribeToTabLabels() {
      if (this._tabLabelSubscription) {
        this._tabLabelSubscription.unsubscribe();
      }
      this._tabLabelSubscription = merge(...this._tabs.map(tab => tab._stateChanges)).subscribe(() => this._changeDetectorRef.markForCheck());
    }
    _clampTabIndex(index) {
      return Math.min(this._tabs.length - 1, Math.max(index || 0, 0));
    }
    _getTabLabelId(tab, index) {
      return tab.id || `${this._groupId}-label-${index}`;
    }
    _getTabContentId(index) {
      return `${this._groupId}-content-${index}`;
    }
    _setTabBodyWrapperHeight(tabHeight) {
      if (!this.dynamicHeight || !this._tabBodyWrapperHeight) {
        this._tabBodyWrapperHeight = tabHeight;
        return;
      }
      const wrapper = this._tabBodyWrapper.nativeElement;
      wrapper.style.height = this._tabBodyWrapperHeight + 'px';
      if (this._tabBodyWrapper.nativeElement.offsetHeight) {
        wrapper.style.height = tabHeight + 'px';
      }
    }
    _removeTabBodyWrapperHeight() {
      const wrapper = this._tabBodyWrapper.nativeElement;
      this._tabBodyWrapperHeight = wrapper.clientHeight;
      wrapper.style.height = '';
      this._ngZone.run(() => this.animationDone.emit());
    }
    _handleClick(tab, tabHeader, index) {
      tabHeader.focusIndex = index;
      if (!tab.disabled) {
        this.selectedIndex = index;
      }
    }
    _getTabIndex(index) {
      const targetIndex = this._lastFocusedTabIndex ?? this.selectedIndex;
      return index === targetIndex ? 0 : -1;
    }
    _tabFocusChanged(focusOrigin, index) {
      if (focusOrigin && focusOrigin !== 'mouse' && focusOrigin !== 'touch') {
        this._tabHeader.focusIndex = index;
      }
    }
    _bodyCentered(isCenter) {
      if (isCenter) {
        this._tabBodies?.forEach((body, i) => body._setActiveClass(i === this._selectedIndex));
      }
    }
    _bodyAnimationsDisabled() {
      return this._diAnimationsDisabled || this._bodyAnimationDuration === '0' || this._bodyAnimationDuration === '0ms';
    }
    static ɵfac = function MatTabGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabGroup)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabGroup,
      selectors: [["mat-tab-group"]],
      contentQueries: function MatTabGroup_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatTab, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allTabs = _t);
        }
      },
      viewQuery: function MatTabGroup_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 5)(_c8, 5)(MatTabBody, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabBodyWrapper = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabHeader = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabBodies = _t);
        }
      },
      hostAttrs: [1, "mat-mdc-tab-group"],
      hostVars: 13,
      hostBindings: function MatTabGroup_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("mat-align-tabs", ctx.alignTabs);
          i0.ɵɵclassMap("mat-" + (ctx.color || "primary"));
          i0.ɵɵstyleProp("--mat-tab-body-animation-duration", ctx._bodyAnimationDuration)("--mat-tab-header-animation-duration", ctx._headerAnimationDuration);
          i0.ɵɵclassProp("mat-mdc-tab-group-dynamic-height", ctx.dynamicHeight)("mat-mdc-tab-group-inverted-header", ctx.headerPosition === "below")("mat-mdc-tab-group-stretch-tabs", ctx.stretchTabs);
        }
      },
      inputs: {
        color: "color",
        fitInkBarToContent: [2, "fitInkBarToContent", "fitInkBarToContent", booleanAttribute],
        stretchTabs: [2, "mat-stretch-tabs", "stretchTabs", booleanAttribute],
        alignTabs: [0, "mat-align-tabs", "alignTabs"],
        dynamicHeight: [2, "dynamicHeight", "dynamicHeight", booleanAttribute],
        selectedIndex: [2, "selectedIndex", "selectedIndex", numberAttribute],
        headerPosition: "headerPosition",
        animationDuration: "animationDuration",
        contentTabIndex: [2, "contentTabIndex", "contentTabIndex", numberAttribute],
        disablePagination: [2, "disablePagination", "disablePagination", booleanAttribute],
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
        preserveContent: [2, "preserveContent", "preserveContent", booleanAttribute],
        backgroundColor: "backgroundColor",
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"]
      },
      outputs: {
        selectedIndexChange: "selectedIndexChange",
        focusChange: "focusChange",
        animationDone: "animationDone",
        selectedTabChange: "selectedTabChange"
      },
      exportAs: ["matTabGroup"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_TAB_GROUP,
        useExisting: MatTabGroup
      }])],
      ngContentSelectors: _c0,
      decls: 9,
      vars: 8,
      consts: [["tabHeader", ""], ["tabBodyWrapper", ""], ["tabNode", ""], [3, "indexFocused", "selectFocusedIndex", "selectedIndex", "disableRipple", "disablePagination", "aria-label", "aria-labelledby"], ["role", "tab", "matTabLabelWrapper", "", "cdkMonitorElementFocus", "", 1, "mdc-tab", "mat-mdc-tab", "mat-focus-indicator", 3, "id", "mdc-tab--active", "class", "disabled", "fitInkBarToContent"], [1, "mat-mdc-tab-body-wrapper"], ["role", "tabpanel", 3, "id", "class", "content", "position", "animationDuration", "preserveContent"], ["role", "tab", "matTabLabelWrapper", "", "cdkMonitorElementFocus", "", 1, "mdc-tab", "mat-mdc-tab", "mat-focus-indicator", 3, "click", "cdkFocusChange", "id", "disabled", "fitInkBarToContent"], [1, "mdc-tab__ripple"], ["mat-ripple", "", 1, "mat-mdc-tab-ripple", 3, "matRippleTrigger", "matRippleDisabled"], [1, "mdc-tab__content"], [1, "mdc-tab__text-label"], [3, "cdkPortalOutlet"], ["role", "tabpanel", 3, "_onCentered", "_onCentering", "_beforeCentering", "id", "content", "position", "animationDuration", "preserveContent"]],
      template: function MatTabGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "mat-tab-header", 3, 0);
          i0.ɵɵlistener("indexFocused", function MatTabGroup_Template_mat_tab_header_indexFocused_0_listener($event) {
            return ctx._focusChanged($event);
          })("selectFocusedIndex", function MatTabGroup_Template_mat_tab_header_selectFocusedIndex_0_listener($event) {
            return ctx.selectedIndex = $event;
          });
          i0.ɵɵrepeaterCreate(2, MatTabGroup_For_3_Template, 8, 17, "div", 4, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
          i0.ɵɵconditionalCreate(4, MatTabGroup_Conditional_4_Template, 1, 0);
          i0.ɵɵelementStart(5, "div", 5, 1);
          i0.ɵɵrepeaterCreate(7, MatTabGroup_For_8_Template, 1, 10, "mat-tab-body", 6, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("selectedIndex", ctx.selectedIndex || 0)("disableRipple", ctx.disableRipple)("disablePagination", ctx.disablePagination);
          i0.ɵɵariaProperty("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledby);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx._tabs);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx._isServer ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("_mat-animation-noopable", ctx._bodyAnimationsDisabled());
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx._tabs);
        }
      },
      dependencies: [MatTabHeader, MatTabLabelWrapper, CdkMonitorFocus, MatRipple, CdkPortalOutlet, MatTabBody],
      styles: [".mdc-tab {\n  min-width: 90px;\n  padding: 0 24px;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  text-align: center;\n  white-space: nowrap;\n  cursor: pointer;\n  z-index: 1;\n  touch-action: manipulation;\n}\n\n.mdc-tab__content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: inherit;\n  pointer-events: none;\n}\n\n.mdc-tab__text-label {\n  transition: 150ms color linear;\n  display: inline-block;\n  line-height: 1;\n  z-index: 2;\n}\n\n.mdc-tab--active .mdc-tab__text-label {\n  transition-delay: 100ms;\n}\n\n._mat-animation-noopable .mdc-tab__text-label {\n  transition: none;\n}\n\n.mdc-tab-indicator {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.mdc-tab-indicator__content {\n  transition: var(--mat-tab-header-animation-duration, 250ms) transform cubic-bezier(0.4, 0, 0.2, 1);\n  transform-origin: left;\n  opacity: 0;\n}\n\n.mdc-tab-indicator__content--underline {\n  align-self: flex-end;\n  box-sizing: border-box;\n  width: 100%;\n  border-top-style: solid;\n}\n\n.mdc-tab-indicator--active .mdc-tab-indicator__content {\n  opacity: 1;\n}\n\n._mat-animation-noopable .mdc-tab-indicator__content, .mdc-tab-indicator--no-transition .mdc-tab-indicator__content {\n  transition: none;\n}\n\n.mat-mdc-tab-ripple.mat-mdc-tab-ripple {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  pointer-events: none;\n}\n\n.mat-mdc-tab {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-decoration: none;\n  background: none;\n  height: var(--mat-tab-container-height, 48px);\n  font-family: var(--mat-tab-label-text-font, var(--mat-sys-title-small-font));\n  font-size: var(--mat-tab-label-text-size, var(--mat-sys-title-small-size));\n  letter-spacing: var(--mat-tab-label-text-tracking, var(--mat-sys-title-small-tracking));\n  line-height: var(--mat-tab-label-text-line-height, var(--mat-sys-title-small-line-height));\n  font-weight: var(--mat-tab-label-text-weight, var(--mat-sys-title-small-weight));\n}\n.mat-mdc-tab.mdc-tab {\n  flex-grow: 0;\n}\n.mat-mdc-tab .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-indicator-color, var(--mat-sys-primary));\n  border-top-width: var(--mat-tab-active-indicator-height, 2px);\n  border-radius: var(--mat-tab-active-indicator-shape, 0);\n}\n.mat-mdc-tab:hover .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-hover-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab:focus .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-focus-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: var(--mat-tab-active-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab.mdc-tab--active .mdc-tab__ripple::before,\n.mat-mdc-tab.mdc-tab--active .mat-ripple-element {\n  background-color: var(--mat-tab-active-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab.mdc-tab--active:hover .mdc-tab__text-label {\n  color: var(--mat-tab-active-hover-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab.mdc-tab--active:hover .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-hover-indicator-color, var(--mat-sys-primary));\n}\n.mat-mdc-tab.mdc-tab--active:focus .mdc-tab__text-label {\n  color: var(--mat-tab-active-focus-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab.mdc-tab--active:focus .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-focus-indicator-color, var(--mat-sys-primary));\n}\n.mat-mdc-tab.mat-mdc-tab-disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n.mat-mdc-tab.mat-mdc-tab-disabled .mdc-tab__content {\n  pointer-events: none;\n}\n.mat-mdc-tab.mat-mdc-tab-disabled .mdc-tab__ripple::before,\n.mat-mdc-tab.mat-mdc-tab-disabled .mat-ripple-element {\n  background-color: var(--mat-tab-disabled-ripple-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-tab .mdc-tab__ripple::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  pointer-events: none;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-label-text-color, var(--mat-sys-on-surface));\n  display: inline-flex;\n  align-items: center;\n}\n.mat-mdc-tab .mdc-tab__content {\n  position: relative;\n  pointer-events: auto;\n}\n.mat-mdc-tab:hover .mdc-tab__ripple::before {\n  opacity: 0.04;\n}\n.mat-mdc-tab.cdk-program-focused .mdc-tab__ripple::before, .mat-mdc-tab.cdk-keyboard-focused .mdc-tab__ripple::before {\n  opacity: 0.12;\n}\n.mat-mdc-tab .mat-ripple-element {\n  opacity: 0.12;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {\n  flex-grow: 1;\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination {\n  background-color: var(--mat-tab-background-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background.mat-primary > .mat-mdc-tab-header .mat-mdc-tab .mdc-tab__text-label {\n  color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background.mat-primary > .mat-mdc-tab-header .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background:not(.mat-primary) > .mat-mdc-tab-header .mat-mdc-tab:not(.mdc-tab--active) .mdc-tab__text-label {\n  color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background:not(.mat-primary) > .mat-mdc-tab-header .mat-mdc-tab:not(.mdc-tab--active) .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header .mat-focus-indicator::before, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-focus-indicator::before {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header .mat-ripple-element, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header .mdc-tab__ripple::before, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-ripple-element, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mdc-tab__ripple::before {\n  background-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header .mat-mdc-tab-header-pagination-chevron, .mat-mdc-tab-group.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-chevron {\n  color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-group.mat-mdc-tab-group-inverted-header {\n  flex-direction: column-reverse;\n}\n.mat-mdc-tab-group.mat-mdc-tab-group-inverted-header .mdc-tab-indicator__content--underline {\n  align-self: flex-start;\n}\n\n.mat-mdc-tab-body-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  transition: height 500ms cubic-bezier(0.35, 0, 0.25, 1);\n}\n.mat-mdc-tab-body-wrapper._mat-animation-noopable {\n  transition: none !important;\n  animation: none !important;\n}\n"],
      encapsulation: 2,
      changeDetection: 1
    });
  }
  return MatTabGroup;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MatTabChangeEvent {
  index;
  tab;
}
let MatTabNav = /*#__PURE__*/(() => {
  class MatTabNav extends MatPaginatedTabHeader {
    _focusedItem = signal(null, ...(ngDevMode ? [{
      debugName: "_focusedItem"
    }] : []));
    get fitInkBarToContent() {
      return this._fitInkBarToContent.value;
    }
    set fitInkBarToContent(value) {
      this._fitInkBarToContent.next(value);
      this._changeDetectorRef.markForCheck();
    }
    _fitInkBarToContent = new BehaviorSubject(false);
    stretchTabs = true;
    animationDuration = '';
    _items;
    get backgroundColor() {
      return this._backgroundColor;
    }
    set backgroundColor(value) {
      const classList = this._elementRef.nativeElement.classList;
      classList.remove('mat-tabs-with-background', `mat-background-${this.backgroundColor}`);
      if (value) {
        classList.add('mat-tabs-with-background', `mat-background-${value}`);
      }
      this._backgroundColor = value;
    }
    _backgroundColor;
    get disableRipple() {
      return this._disableRipple();
    }
    set disableRipple(value) {
      this._disableRipple.set(value);
    }
    _disableRipple = signal(false, ...(ngDevMode ? [{
      debugName: "_disableRipple"
    }] : []));
    color = 'primary';
    tabPanel;
    _tabListContainer;
    _tabList;
    _tabListInner;
    _nextPaginator;
    _previousPaginator;
    _inkBar;
    constructor() {
      const defaultConfig = inject(MAT_TABS_CONFIG, {
        optional: true
      });
      super();
      this.disablePagination = defaultConfig && defaultConfig.disablePagination != null ? defaultConfig.disablePagination : false;
      this.fitInkBarToContent = defaultConfig && defaultConfig.fitInkBarToContent != null ? defaultConfig.fitInkBarToContent : false;
      this.stretchTabs = defaultConfig && defaultConfig.stretchTabs != null ? defaultConfig.stretchTabs : true;
    }
    _itemSelected() {}
    ngAfterContentInit() {
      this._inkBar = new MatInkBar(this._items);
      this._items.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => this.updateActiveLink());
      super.ngAfterContentInit();
      this._keyManager.change.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => this._focusedItem.set(this._keyManager?.activeItem || null));
    }
    ngAfterViewInit() {
      if (!this.tabPanel && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw new Error('A mat-tab-nav-panel must be specified via [tabPanel].');
      }
      super.ngAfterViewInit();
    }
    updateActiveLink() {
      if (!this._items) {
        return;
      }
      const items = this._items.toArray();
      for (let i = 0; i < items.length; i++) {
        if (items[i].active) {
          this.selectedIndex = i;
          if (this.tabPanel) {
            this.tabPanel._activeTabId = items[i].id;
          }
          this._focusedItem.set(items[i]);
          this._changeDetectorRef.markForCheck();
          return;
        }
      }
      this.selectedIndex = -1;
    }
    _getRole() {
      return this.tabPanel ? 'tablist' : this._elementRef.nativeElement.getAttribute('role');
    }
    _hasFocus(link) {
      return this._keyManager?.activeItem === link;
    }
    static ɵfac = function MatTabNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabNav)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabNav,
      selectors: [["", "mat-tab-nav-bar", ""]],
      contentQueries: function MatTabNav_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatTabLink, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._items = _t);
        }
      },
      viewQuery: function MatTabNav_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 7)(_c2, 7)(_c3, 7)(_c4, 5)(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabListContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabListInner = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nextPaginator = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._previousPaginator = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-tab-nav-bar", "mat-mdc-tab-header"],
      hostVars: 17,
      hostBindings: function MatTabNav_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx._getRole());
          i0.ɵɵstyleProp("--mat-tab-header-animation-duration", ctx.animationDuration);
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-controls-enabled", ctx._showPaginationControls)("mat-mdc-tab-header-rtl", ctx._getLayoutDirection() == "rtl")("mat-mdc-tab-nav-bar-stretch-tabs", ctx.stretchTabs)("mat-primary", ctx.color !== "warn" && ctx.color !== "accent")("mat-accent", ctx.color === "accent")("mat-warn", ctx.color === "warn")("_mat-animation-noopable", ctx._animationsDisabled);
        }
      },
      inputs: {
        fitInkBarToContent: [2, "fitInkBarToContent", "fitInkBarToContent", booleanAttribute],
        stretchTabs: [2, "mat-stretch-tabs", "stretchTabs", booleanAttribute],
        animationDuration: [2, "animationDuration", "animationDuration", normalizeDuration],
        backgroundColor: "backgroundColor",
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
        color: "color",
        tabPanel: "tabPanel"
      },
      exportAs: ["matTabNavBar", "matTabNav"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 13,
      vars: 6,
      consts: [["previousPaginator", ""], ["tabListContainer", ""], ["tabList", ""], ["tabListInner", ""], ["nextPaginator", ""], ["mat-ripple", "", 1, "mat-mdc-tab-header-pagination", "mat-mdc-tab-header-pagination-before", 3, "click", "mousedown", "touchend", "matRippleDisabled"], [1, "mat-mdc-tab-header-pagination-chevron"], [1, "mat-mdc-tab-link-container", 3, "keydown"], [1, "mat-mdc-tab-list", 3, "cdkObserveContent"], [1, "mat-mdc-tab-links"], ["mat-ripple", "", 1, "mat-mdc-tab-header-pagination", "mat-mdc-tab-header-pagination-after", 3, "mousedown", "click", "touchend", "matRippleDisabled"]],
      template: function MatTabNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 5, 0);
          i0.ɵɵlistener("click", function MatTabNav_Template_div_click_0_listener() {
            return ctx._handlePaginatorClick("before");
          })("mousedown", function MatTabNav_Template_div_mousedown_0_listener($event) {
            return ctx._handlePaginatorPress("before", $event);
          })("touchend", function MatTabNav_Template_div_touchend_0_listener() {
            return ctx._stopInterval();
          });
          i0.ɵɵelement(2, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 7, 1);
          i0.ɵɵlistener("keydown", function MatTabNav_Template_div_keydown_3_listener($event) {
            return ctx._handleKeydown($event);
          });
          i0.ɵɵelementStart(5, "div", 8, 2);
          i0.ɵɵlistener("cdkObserveContent", function MatTabNav_Template_div_cdkObserveContent_5_listener() {
            return ctx._onContentChanges();
          });
          i0.ɵɵelementStart(7, "div", 9, 3);
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(10, "div", 10, 4);
          i0.ɵɵlistener("mousedown", function MatTabNav_Template_div_mousedown_10_listener($event) {
            return ctx._handlePaginatorPress("after", $event);
          })("click", function MatTabNav_Template_div_click_10_listener() {
            return ctx._handlePaginatorClick("after");
          })("touchend", function MatTabNav_Template_div_touchend_10_listener() {
            return ctx._stopInterval();
          });
          i0.ɵɵelement(12, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-disabled", ctx._disableScrollBefore);
          i0.ɵɵproperty("matRippleDisabled", ctx._disableScrollBefore || ctx.disableRipple);
          i0.ɵɵadvance(10);
          i0.ɵɵclassProp("mat-mdc-tab-header-pagination-disabled", ctx._disableScrollAfter);
          i0.ɵɵproperty("matRippleDisabled", ctx._disableScrollAfter || ctx.disableRipple);
        }
      },
      dependencies: [MatRipple, CdkObserveContent],
      styles: [".mdc-tab {\n  min-width: 90px;\n  padding: 0 24px;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  text-align: center;\n  white-space: nowrap;\n  cursor: pointer;\n  z-index: 1;\n  touch-action: manipulation;\n}\n\n.mdc-tab__content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: inherit;\n  pointer-events: none;\n}\n\n.mdc-tab__text-label {\n  transition: 150ms color linear;\n  display: inline-block;\n  line-height: 1;\n  z-index: 2;\n}\n\n.mdc-tab--active .mdc-tab__text-label {\n  transition-delay: 100ms;\n}\n\n._mat-animation-noopable .mdc-tab__text-label {\n  transition: none;\n}\n\n.mdc-tab-indicator {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.mdc-tab-indicator__content {\n  transition: var(--mat-tab-header-animation-duration, 250ms) transform cubic-bezier(0.4, 0, 0.2, 1);\n  transform-origin: left;\n  opacity: 0;\n}\n\n.mdc-tab-indicator__content--underline {\n  align-self: flex-end;\n  box-sizing: border-box;\n  width: 100%;\n  border-top-style: solid;\n}\n\n.mdc-tab-indicator--active .mdc-tab-indicator__content {\n  opacity: 1;\n}\n\n._mat-animation-noopable .mdc-tab-indicator__content, .mdc-tab-indicator--no-transition .mdc-tab-indicator__content {\n  transition: none;\n}\n\n.mat-mdc-tab-ripple.mat-mdc-tab-ripple {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  pointer-events: none;\n}\n\n.mat-mdc-tab-header {\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.mdc-tab-indicator .mdc-tab-indicator__content {\n  transition-duration: var(--mat-tab-header-animation-duration, 250ms);\n}\n\n.mat-mdc-tab-header-pagination {\n  -webkit-user-select: none;\n  user-select: none;\n  position: relative;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  min-width: 32px;\n  cursor: pointer;\n  z-index: 2;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: none;\n  box-sizing: content-box;\n  outline: 0;\n}\n.mat-mdc-tab-header-pagination::-moz-focus-inner {\n  border: 0;\n}\n.mat-mdc-tab-header-pagination .mat-ripple-element {\n  opacity: 0.12;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-header-pagination-controls-enabled .mat-mdc-tab-header-pagination {\n  display: flex;\n}\n\n.mat-mdc-tab-header-pagination-before,\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-after {\n  padding-left: 4px;\n}\n.mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-after .mat-mdc-tab-header-pagination-chevron {\n  transform: rotate(-135deg);\n}\n\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-before,\n.mat-mdc-tab-header-pagination-after {\n  padding-right: 4px;\n}\n.mat-mdc-tab-header-rtl .mat-mdc-tab-header-pagination-before .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-header-pagination-after .mat-mdc-tab-header-pagination-chevron {\n  transform: rotate(45deg);\n}\n\n.mat-mdc-tab-header-pagination-chevron {\n  border-style: solid;\n  border-width: 2px 2px 0 0;\n  height: 8px;\n  width: 8px;\n  border-color: var(--mat-tab-pagination-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-tab-header-pagination-disabled {\n  box-shadow: none;\n  cursor: default;\n  pointer-events: none;\n}\n.mat-mdc-tab-header-pagination-disabled .mat-mdc-tab-header-pagination-chevron {\n  opacity: 0.4;\n}\n\n.mat-mdc-tab-list {\n  flex-grow: 1;\n  position: relative;\n  transition: transform 500ms cubic-bezier(0.35, 0, 0.25, 1);\n}\n._mat-animation-noopable .mat-mdc-tab-list {\n  transition: none;\n}\n\n.mat-mdc-tab-links {\n  display: flex;\n  flex: 1 0 auto;\n}\n[mat-align-tabs=center] > .mat-mdc-tab-link-container .mat-mdc-tab-links {\n  justify-content: center;\n}\n[mat-align-tabs=end] > .mat-mdc-tab-link-container .mat-mdc-tab-links {\n  justify-content: flex-end;\n}\n.cdk-drop-list .mat-mdc-tab-links, .mat-mdc-tab-links.cdk-drop-list {\n  min-height: var(--mat-tab-container-height, 48px);\n}\n\n.mat-mdc-tab-link-container {\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  z-index: 1;\n  border-bottom-style: solid;\n  border-bottom-width: var(--mat-tab-divider-height, 1px);\n  border-bottom-color: var(--mat-tab-divider-color, var(--mat-sys-surface-variant));\n}\n\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination {\n  background-color: var(--mat-tab-background-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background.mat-primary > .mat-mdc-tab-link-container .mat-mdc-tab-link .mdc-tab__text-label {\n  color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background.mat-primary > .mat-mdc-tab-link-container .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background:not(.mat-primary) > .mat-mdc-tab-link-container .mat-mdc-tab-link:not(.mdc-tab--active) .mdc-tab__text-label {\n  color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background:not(.mat-primary) > .mat-mdc-tab-link-container .mat-mdc-tab-link:not(.mdc-tab--active) .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container .mat-focus-indicator::before, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-chevron,\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-focus-indicator::before {\n  border-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container .mat-ripple-element, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container .mdc-tab__ripple::before, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-ripple-element, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mdc-tab__ripple::before {\n  background-color: var(--mat-tab-foreground-color);\n}\n.mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-link-container .mat-mdc-tab-header-pagination-chevron, .mat-mdc-tab-nav-bar.mat-tabs-with-background > .mat-mdc-tab-header-pagination .mat-mdc-tab-header-pagination-chevron {\n  color: var(--mat-tab-foreground-color);\n}\n"],
      encapsulation: 2,
      changeDetection: 1
    });
  }
  return MatTabNav;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabLink = /*#__PURE__*/(() => {
  class MatTabLink extends InkBarItem {
    _tabNavBar = inject(MatTabNav);
    elementRef = inject(ElementRef);
    _focusMonitor = inject(FocusMonitor);
    _destroyed = new Subject();
    _isActive = false;
    _tabIndex = computed(() => this._tabNavBar._focusedItem() === this ? this.tabIndex : -1, ...(ngDevMode ? [{
      debugName: "_tabIndex"
    }] : []));
    get active() {
      return this._isActive;
    }
    set active(value) {
      if (value !== this._isActive) {
        this._isActive = value;
        this._tabNavBar.updateActiveLink();
      }
    }
    disabled = false;
    get disableRipple() {
      return this._disableRipple();
    }
    set disableRipple(value) {
      this._disableRipple.set(value);
    }
    _disableRipple = signal(false, ...(ngDevMode ? [{
      debugName: "_disableRipple"
    }] : []));
    tabIndex = 0;
    rippleConfig;
    get rippleDisabled() {
      return this.disabled || this.disableRipple || this._tabNavBar.disableRipple || !!this.rippleConfig.disabled;
    }
    id = inject(_IdGenerator).getId('mat-tab-link-');
    constructor() {
      super();
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
      const globalRippleOptions = inject(MAT_RIPPLE_GLOBAL_OPTIONS, {
        optional: true
      });
      const tabIndex = inject(new HostAttributeToken('tabindex'), {
        optional: true
      });
      this.rippleConfig = globalRippleOptions || {};
      this.tabIndex = tabIndex == null ? 0 : parseInt(tabIndex) || 0;
      if (_animationsDisabled()) {
        this.rippleConfig.animation = {
          enterDuration: 0,
          exitDuration: 0
        };
      }
      this._tabNavBar._fitInkBarToContent.pipe(takeUntil(this._destroyed)).subscribe(fitInkBarToContent => {
        this.fitInkBarToContent = fitInkBarToContent;
      });
    }
    focus() {
      this.elementRef.nativeElement.focus();
    }
    ngAfterViewInit() {
      this._focusMonitor.monitor(this.elementRef);
    }
    ngOnDestroy() {
      this._destroyed.next();
      this._destroyed.complete();
      super.ngOnDestroy();
      this._focusMonitor.stopMonitoring(this.elementRef);
    }
    _handleFocus() {
      this._tabNavBar.focusIndex = this._tabNavBar._items.toArray().indexOf(this);
    }
    _handleKeydown(event) {
      if (event.keyCode === SPACE || event.keyCode === ENTER) {
        if (this.disabled) {
          event.preventDefault();
        } else if (this._tabNavBar.tabPanel) {
          if (event.keyCode === SPACE) {
            event.preventDefault();
          }
          this.elementRef.nativeElement.click();
        }
      }
    }
    _getAriaControls() {
      return this._tabNavBar.tabPanel ? this._tabNavBar.tabPanel?.id : this.elementRef.nativeElement.getAttribute('aria-controls');
    }
    _getAriaSelected() {
      if (this._tabNavBar.tabPanel) {
        return this.active ? 'true' : 'false';
      } else {
        return this.elementRef.nativeElement.getAttribute('aria-selected');
      }
    }
    _getAriaCurrent() {
      return this.active && !this._tabNavBar.tabPanel ? 'page' : null;
    }
    _getRole() {
      return this._tabNavBar.tabPanel ? 'tab' : this.elementRef.nativeElement.getAttribute('role');
    }
    static ɵfac = function MatTabLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabLink)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabLink,
      selectors: [["", "mat-tab-link", ""], ["", "matTabLink", ""]],
      hostAttrs: [1, "mdc-tab", "mat-mdc-tab-link", "mat-focus-indicator"],
      hostVars: 11,
      hostBindings: function MatTabLink_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatTabLink_focus_HostBindingHandler() {
            return ctx._handleFocus();
          })("keydown", function MatTabLink_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-controls", ctx._getAriaControls())("aria-current", ctx._getAriaCurrent())("aria-disabled", ctx.disabled)("aria-selected", ctx._getAriaSelected())("id", ctx.id)("tabIndex", ctx._tabIndex())("role", ctx._getRole());
          i0.ɵɵclassProp("mat-mdc-tab-disabled", ctx.disabled)("mdc-tab--active", ctx.active);
        }
      },
      inputs: {
        active: [2, "active", "active", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? 0 : numberAttribute(value)],
        id: "id"
      },
      exportAs: ["matTabLink"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 2,
      consts: [[1, "mdc-tab__ripple"], ["mat-ripple", "", 1, "mat-mdc-tab-ripple", 3, "matRippleTrigger", "matRippleDisabled"], [1, "mdc-tab__content"], [1, "mdc-tab__text-label"]],
      template: function MatTabLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelement(0, "span", 0)(1, "div", 1);
          i0.ɵɵelementStart(2, "span", 2)(3, "span", 3);
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("matRippleTrigger", ctx.elementRef.nativeElement)("matRippleDisabled", ctx.rippleDisabled);
        }
      },
      dependencies: [MatRipple],
      styles: [".mat-mdc-tab-link {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-decoration: none;\n  background: none;\n  height: var(--mat-tab-container-height, 48px);\n  font-family: var(--mat-tab-label-text-font, var(--mat-sys-title-small-font));\n  font-size: var(--mat-tab-label-text-size, var(--mat-sys-title-small-size));\n  letter-spacing: var(--mat-tab-label-text-tracking, var(--mat-sys-title-small-tracking));\n  line-height: var(--mat-tab-label-text-line-height, var(--mat-sys-title-small-line-height));\n  font-weight: var(--mat-tab-label-text-weight, var(--mat-sys-title-small-weight));\n}\n.mat-mdc-tab-link.mdc-tab {\n  flex-grow: 0;\n}\n.mat-mdc-tab-link .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-indicator-color, var(--mat-sys-primary));\n  border-top-width: var(--mat-tab-active-indicator-height, 2px);\n  border-radius: var(--mat-tab-active-indicator-shape, 0);\n}\n.mat-mdc-tab-link:hover .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-hover-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link:focus .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-focus-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link.mdc-tab--active .mdc-tab__text-label {\n  color: var(--mat-tab-active-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link.mdc-tab--active .mdc-tab__ripple::before,\n.mat-mdc-tab-link.mdc-tab--active .mat-ripple-element {\n  background-color: var(--mat-tab-active-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link.mdc-tab--active:hover .mdc-tab__text-label {\n  color: var(--mat-tab-active-hover-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link.mdc-tab--active:hover .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-hover-indicator-color, var(--mat-sys-primary));\n}\n.mat-mdc-tab-link.mdc-tab--active:focus .mdc-tab__text-label {\n  color: var(--mat-tab-active-focus-label-text-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link.mdc-tab--active:focus .mdc-tab-indicator__content--underline {\n  border-color: var(--mat-tab-active-focus-indicator-color, var(--mat-sys-primary));\n}\n.mat-mdc-tab-link.mat-mdc-tab-disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n.mat-mdc-tab-link.mat-mdc-tab-disabled .mdc-tab__content {\n  pointer-events: none;\n}\n.mat-mdc-tab-link.mat-mdc-tab-disabled .mdc-tab__ripple::before,\n.mat-mdc-tab-link.mat-mdc-tab-disabled .mat-ripple-element {\n  background-color: var(--mat-tab-disabled-ripple-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-tab-link .mdc-tab__ripple::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  pointer-events: none;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-link .mdc-tab__text-label {\n  color: var(--mat-tab-inactive-label-text-color, var(--mat-sys-on-surface));\n  display: inline-flex;\n  align-items: center;\n}\n.mat-mdc-tab-link .mdc-tab__content {\n  position: relative;\n  pointer-events: auto;\n}\n.mat-mdc-tab-link:hover .mdc-tab__ripple::before {\n  opacity: 0.04;\n}\n.mat-mdc-tab-link.cdk-program-focused .mdc-tab__ripple::before, .mat-mdc-tab-link.cdk-keyboard-focused .mdc-tab__ripple::before {\n  opacity: 0.12;\n}\n.mat-mdc-tab-link .mat-ripple-element {\n  opacity: 0.12;\n  background-color: var(--mat-tab-inactive-ripple-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {\n  flex-grow: 1;\n}\n.mat-mdc-tab-link::before {\n  margin: 5px;\n}\n\n@media (max-width: 599px) {\n  .mat-mdc-tab-link {\n    min-width: 72px;\n  }\n}\n"],
      encapsulation: 2
    });
  }
  return MatTabLink;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabNavPanel = /*#__PURE__*/(() => {
  class MatTabNavPanel {
    id = inject(_IdGenerator).getId('mat-tab-nav-panel-');
    _activeTabId;
    static ɵfac = function MatTabNavPanel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabNavPanel)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatTabNavPanel,
      selectors: [["mat-tab-nav-panel"]],
      hostAttrs: ["role", "tabpanel", 1, "mat-mdc-tab-nav-panel"],
      hostVars: 2,
      hostBindings: function MatTabNavPanel_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-labelledby", ctx._activeTabId)("id", ctx.id);
        }
      },
      inputs: {
        id: "id"
      },
      exportAs: ["matTabNavPanel"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function MatTabNavPanel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
  return MatTabNavPanel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatTabsModule = /*#__PURE__*/(() => {
  class MatTabsModule {
    static ɵfac = function MatTabsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTabsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatTabsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [BidiModule]
    });
  }
  return MatTabsModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MAT_TAB, MAT_TABS_CONFIG, MAT_TAB_CONTENT, MAT_TAB_GROUP, MAT_TAB_LABEL, MatInkBar, MatPaginatedTabHeader, MatTab, MatTabBody, MatTabBodyPortal, MatTabChangeEvent, MatTabContent, MatTabGroup, MatTabHeader, MatTabLabel, MatTabLabelWrapper, MatTabLink, MatTabNav, MatTabNavPanel, MatTabsModule, _MAT_INK_BAR_POSITIONER };
